import React from 'react';
import { Paper, Typography, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

interface Member {
    name: string;
    institution: string;
    role: string;
    bond: string;
    start: string;
    end: string;
}

interface Step2CmdrsViewProps {
    data: {
        members: Member[];
    };
}

// Função utilitária para formatar data no padrão brasileiro
const formatDateBr = (dateStr: string) => {
    if (!dateStr) return 'Não informado';
    const [year, month, day] = dateStr.split('-');
    if (!year || !month || !day) return dateStr;
    return `${day}/${month}/${year}`;
};

const Step2CmdrsView: React.FC<Step2CmdrsViewProps> = ({ data }) => (
    <Paper elevation={1} sx={{ p: 3, mt: 2 }}>
        <Typography variant="h5" color="primary" gutterBottom>
            Diretoria Executiva do CMDRS
        </Typography>
        <Divider sx={{ mb: 3 }} />

        {data.members && data.members.length > 0 ? (
            <TableContainer component={Paper} elevation={0}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell><strong>Nome</strong></TableCell>
                            <TableCell><strong>Instituição</strong></TableCell>
                            <TableCell><strong>Função</strong></TableCell>
                            <TableCell><strong>Vínculo</strong></TableCell>
                            <TableCell><strong>Início do mandato</strong></TableCell>
                            <TableCell><strong>Fim do mandato</strong></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.members.map((member, idx) => (
                            <TableRow key={idx}>
                                <TableCell>{member.name || 'Não informado'}</TableCell>
                                <TableCell>{member.institution || 'Não informado'}</TableCell>
                                <TableCell>{member.role || 'Não informado'}</TableCell>
                                <TableCell>{member.bond || 'Não informado'}</TableCell>
                                <TableCell>{formatDateBr(member.start)}</TableCell>
                                <TableCell>{formatDateBr(member.end)}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        ) : (
            <Typography color="text.secondary">Nenhum membro cadastrado.</Typography>
        )}
    </Paper>
);

export default Step2CmdrsView;